import React from 'react'
import './index.css'

export class FadeSpan extends React.Component {
  setRef = ref => {
    this.ref = ref
  }

  componentDidMount() {
    const index = Number(this.props.info && this.props.info.index) || 0
    requestAnimationFrame(() => {
      if (!this.ref) return
      this.ref.style.transitionDelay = `${index * 0.01}ms`
      requestAnimationFrame(() => {
        if (this.ref) this.ref.classList.add('fade-span-visible')
      })
    })
  }

  render() {
    const { id } = this.props.info || {}
    return <span id={id} ref={this.setRef} className='fade-span'>{this.props.children}</span>
  }
}

// Streaming Markdown must produce exactly the same element tree as completed
// Markdown. This class decorates the real renderer and changes only its text
// children, wrapping newly keyed characters in opacity-only spans.
export class FadeComponents {
  constructor({ id, components = {} }) {
    this.id = id
    this.components = components

    const tags = new Set([
      'p', 'ul', 'ol', 'li', 'table', 'thead', 'tbody', 'tr', 'th', 'td',
      'hr', 'h1', 'h2', 'h3', 'strong', 'em', 'a', 'del', 'blockquote',
      'code', 'pre', 'img', 'check', 'antthinking', 'think', 'reasoning',
      'signed', 'gemini-sig', 'openai-sig'
    ])
    Object.keys(components).forEach(tag => tags.add(tag))
    tags.forEach(tag => {
      this[tag] = opts => this.renderComponent(tag, opts)
    })
  }

  reset = fade => {
    this.index = 0
    this.fade = Boolean(fade)
  }

  index = 0
  fade = true

  rawChildrenTags = new Set(['code'])

  wrapText = children => {
    if (!this.fade || children === null || children === undefined) return children
    if (Array.isArray(children)) return children.map(this.wrapText)
    if (typeof children !== 'string') return children
    return Array.from(children, char => {
      const index = this.index++
      const key = `${this.id}-fade-span-${index}`
      return <FadeSpan key={key} info={{ index, id: key }}>{char}</FadeSpan>
    })
  }

  renderComponent = (tag, opts = {}) => {
    const renderer = this.components[tag]
    // CodeBlock determines inline/block rendering and copy contents from its
    // raw string child. Replacing that string with FadeSpan elements makes it
    // resolve to an empty string. Structural renderers must receive precisely
    // the same children as the completed-message renderer.
    const children = this.rawChildrenTags.has(tag)
      ? opts.children
      : this.wrapText(opts.children)
    if (renderer) return React.createElement(renderer, { ...opts, children })
    const { node, ...nativeProps } = opts
    return React.createElement(tag, { ...nativeProps, children })
  }
}
